<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="modalTitle"
  [nzFooter]="modalFooter"
  (nzOnCancel)="close()"
  [nzWidth]="420"
>
  <ng-template #modalTitle>
    <app-modal-title [icon]="config.icon" [title]="config.title" />
  </ng-template>

  <div *nzModalContent>
    @if (prospect?.sprospecto) {
      <div class="prospect-name">
        <span nz-icon nzType="user" nzTheme="outline"></span>
        {{ prospect!.sprospecto }}
      </div>
    }
    @if (googleCal.accessToken$ | async) {
      <div class="google-status google-status--connected">
        <span nz-icon nzType="check-circle" nzTheme="fill"></span>
        <span>Google conectado</span>
      </div>
    } @else {
      <nz-alert
        nzType="warning"
        nzMessage="Google Calendar no conectado"
        nzDescription="Conecta tu cuenta de Google para registrar el evento en el calendario."
        [nzAction]="connectBtn"
        nzShowIcon
        class="mb-3"
      ></nz-alert>
      <ng-template #connectBtn>
        <button
          nz-button
          nzSize="small"
          nzType="default"
          type="button"
          class="btn-connect-google"
          [nzLoading]="connectingGoogle"
          (click)="connectGoogle()"
        >
          Conectar
        </button>
      </ng-template>
    }
    <form nz-form [formGroup]="form" nzLayout="vertical">
      <div class="grid grid-cols-2 gap-4">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="fecha">Fecha</nz-form-label>
          <nz-form-control nzErrorTip="La fecha es requerida">
            <nz-date-picker
              formControlName="fecha"
              id="fecha"
              nzPlaceHolder="Seleccionar fecha"
              [nzDisabledDate]="disabledDate"
              style="width: 100%"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired nzFor="hora">Hora</nz-form-label>
          <nz-form-control nzErrorTip="La hora es requerida">
            <nz-time-picker
              formControlName="hora"
              id="hora"
              nzPlaceHolder="Seleccionar hora"
              nzFormat="HH:mm"
              [nzMinuteStep]="10"
              [nzDisabledHours]="disabledHours"
              [nzDisabledMinutes]="disabledMinutes"
              style="width: 100%"
            ></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
      </div>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="scomentario">Razón / Comentarios</nz-form-label>
        <nz-form-control nzErrorTip="Ingresa un comentario válido (letras, números y puntuación básica)">
          <textarea
            nz-input
            formControlName="scomentario"
            id="scomentario"
            [placeholder]="config.commentPlaceholder"
            [nzAutosize]="{ minRows: 3, maxRows: 5 }"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="slink">Enlace de reunión (opcional)</nz-form-label>
        <nz-form-control nzErrorTip="Debe ser un enlace de Meet, Zoom o Teams (https://...)">
          <input
            nz-input
            formControlName="slink"
            id="slink"
            placeholder="https://meet.google.com/... | https://zoom.us/... | https://teams.microsoft.com/..."
          />
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>

  <ng-template #modalFooter>
    <div class="modal-footer">
      <button nz-button class="sinay-outline-reset" (click)="close()">Cancelar</button>
      <button nz-button class="btn-add" [nzLoading]="saving" [disabled]="!googleConnected" (click)="save()">{{ config.buttonLabel }}</button>
    </div>
  </ng-template>
</nz-modal>
